export default "__VITE_ASSET__YCZVMa_C__"